import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "..";
import { initialMasterStatus, initialStatusState } from "./status.types";
import {
  CLEAR_STATUS_STATE,
  FETCH_MASTER_STATUS_LIST_PROGRESS,
  FETCH_MASTER_STATUS_LIST_SUCCESS,
  FETCH_MASTER_STATUS_LIST_FAILED,
  FETCH_MASTER_STATUS_PROGRESS,
  FETCH_MASTER_STATUS_SUCCESS,
  FETCH_MASTER_STATUS_FAILED,
  CLEAR_MASTER_STATUS_STATE,
} from "./statusAction";

export const statusReducer = (
  state: IStoreState["status"] = initialStatusState,
  action: any,
) => {
  switch (action.type) {
    // List Actions

    case FETCH_MASTER_STATUS_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.masterStatusList.loading = LoadState.NotLoaded;
        draftState.masterStatusList.list = [];
        draftState.masterStatusList.totalRecords = 0;
        draftState.masterStatusList.error = null;
      });
    }

    case FETCH_MASTER_STATUS_LIST_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.masterStatusList.loading = LoadState.Loaded;
        draftState.masterStatusList.list = data;
        draftState.masterStatusList.error = null;
      });
    }

    case FETCH_MASTER_STATUS_LIST_FAILED: {
      const { errorMessage } = action.payload;
      return produce(state, (draftState) => {
        draftState.masterStatusList.loading = LoadState.Failed;
        draftState.masterStatusList.error = errorMessage;
      });
    }

    // Single Status Actions
    case FETCH_MASTER_STATUS_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.masterStatus.loading = LoadState.InProgress;
        draftState.masterStatus.data = initialMasterStatus;
      });
    }

    case FETCH_MASTER_STATUS_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.masterStatus.loading = LoadState.Loaded;
        draftState.masterStatus.data = data;
        draftState.masterStatus.error = null;
      });
    }

    case FETCH_MASTER_STATUS_FAILED: {
      return produce(state, (draftState) => {
        draftState.masterStatus.loading = LoadState.Failed;
      });
    }

    case CLEAR_STATUS_STATE: {
      return initialStatusState;
    }
    case CLEAR_MASTER_STATUS_STATE: {
      return initialStatusState;
    }

    default: {
      return state;
    }
  }
};
